import * as z from 'zod';
import { dateTimeSchema } from '../../enums.mjs';
import { userId } from '../opaque.mjs';
import { formulaSchema } from './formula.mjs';

var Adjustment;
(function (Adjustment) {
    Adjustment.schema = z.object({
        formula: formulaSchema,
        createdByUserId: userId.nullable(),
        createdAt: dateTimeSchema,
        note: z.string().optional(),
    });
})(Adjustment || (Adjustment = {}));

export { Adjustment };
